import React, { Component } from 'react';
import './estimateProgress.scss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as budgetActions from '../../actions/budgetActions';
import * as mandatoriesActions from '../../actions/mandatoriesActions';
import * as lineItemActions from '../../actions/lineItemActions';
import PropTypes from 'prop-types';

class EstimateProgress extends Component {

  render() {
		const cash =  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    return (
      <div className="a-fixed-position-estimate-notification">
				<div className='spacer-gif'>
					<h3><small>Project Cost: </small> {cash.format(Math.round(this.props.cost*.95))}—
							{cash.format(Math.round(this.props.cost*1.05))}</h3>
				</div>
			</div>
    );
  }
}

EstimateProgress.propTypes = {
	match : PropTypes.object,
	budget: PropTypes.object
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		actions: bindActionCreators(budgetActions, dispatch),
		lineItemActions: bindActionCreators(lineItemActions, dispatch),
		mandatoriesActions: bindActionCreators(mandatoriesActions, dispatch)
	};
}

const mapStateToProps = (state, ownProps) => {
	let budget = state.budgets.length < 1 ? null : state.budgets.find((obj) => {if(obj.id === ownProps.id) return obj});
	let cost = 0;
  let genConCost = 0;
  let furnishInstallCost = 0;
  let finishLevelCost = 0;
  let healthcareGenCost = new Map();
	const sqFt = state.mandatories.projectSqFt === "" ? Number(0) : state.mandatories.projectSqFt;
	const assoc = state.mandatories.associates === "" ? Number(0) : state.mandatories.associates;
  if (budget) {
    if( budget.lines != null && budget.lines.length > 0 ) {
  		for( let boo in budget.lines) {
  			let index = "li" + budget.lines[boo].id;
        if (state.lineItems[index] !== undefined) {
          if(state.estimates[index] !== undefined && state.lineItems[index].items !== undefined) {
    				// now we found an element in the item repository with budget figures
    				// lets dive and look at what actual item values are
    				for(let key in state.lineItems[index].items){
    					if(state.estimates[index][key] !== undefined) {
    						key = Number(key);
    						let item = state.lineItems[index].items[key];
    						if(item.item_type === "fieldGrid") {

    							// Heres the kicker... anytime we have a field grid
    							// we check the following item to see if it's a slider
    							// if we find a slider we stop parsing this grid item and
    							// parse it with the slider.
    							if(state.lineItems[index].items[key+1] !== undefined &&
    								state.lineItems[index].items[key+1].item_type === "slider") {

    									continue;
    							} else {
    								for( let wha in item.grid) {
    									const val = item.grid[wha];
    									var tmp = state.estimates[index][key].selectedValues[wha] === undefined
    										? Number(0)
    										: Number(state.estimates[index][key].selectedValues[wha]);
    									switch(val.cost_basis) {
    										case 'assoc' :
    											cost += Number(val.base_cost) * tmp * assoc;
    											break;
    										case 'sqft' :
    											cost +=	Number(val.base_cost) * tmp * sqFt;
    											break;
    										case 'flat' :
    											cost +=	Number(val.base_cost) * tmp;
    											break;
                        case 'healthcare' :
                          healthcareGenCost.set(val.title, val.base_cost * tmp);
                          break;
    										default :
    											cost +=	Number(val.base_cost) * tmp;
    									}
                      if (item.apply_general_conditions == true) {
                        switch(val.cost_basis) {
                          case 'assoc' :
      											genConCost += Number(val.base_cost) * tmp * assoc;
      											break;
      										case 'sqft' :
      											genConCost +=	Number(val.base_cost) * tmp * sqFt;
      											break;
      										case 'flat' :
      											genConCost +=	Number(val.base_cost) * tmp;
      											break;
      										default :
      											genConCost +=	Number(val.base_cost) * tmp;
                        }
                      }
                      if (item.apply_furnish_install == true) {
                        switch(val.cost_basis) {
                          case 'assoc' :
      											furnishInstallCost += Number(val.base_cost) * tmp * assoc;
      											break;
      										case 'sqft' :
      											furnishInstallCost +=	Number(val.base_cost) * tmp * sqFt;
      											break;
      										case 'flat' :
      											furnishInstallCost +=	Number(val.base_cost) * tmp;
      											break;
      										default :
      											furnishInstallCost +=	Number(val.base_cost) * tmp;
                        }
                      }
    								}
    							}
    						}

    						if(item.item_type === 'slider') {
    							// This side of the if/else handles sliders when they relate to
    							// grids
    							if(state.lineItems[index].items[key-1] !== undefined &&
    								state.lineItems[index].items[key-1].item_type === "fieldGrid" &&
    								state.estimates[index][key-1] !== undefined) {
    									// When working with slider remember that the slider reports it's value as on the
    									// first step as "1", because everything else operates on a zero index we subtract
    									// '1' from the value of the slider.
    									const sel = state.estimates[index][key].selectedSliderIndex === null ? 0 : state.estimates[index][key].selectedSliderIndex-1;
    									const sliderText = state.lineItems[index].items[key].slider.stops[sel];
    									const gridItem = state.lineItems[index].items[key-1];
    									const gridEst = state.estimates[index][key-1];

    									for(var gI in gridItem.grid) {
    										if(gridEst.selectedValues[gI] !== undefined && Number(gridEst.selectedValues[gI]) > 0) {
    											cost += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)
    												*Number(gridEst.selectedValues[gI]);
                          if (item.apply_general_conditions == true) {
                            genConCost += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)
      												*Number(gridEst.selectedValues[gI]);
                          }
                          if (item.apply_furnish_install == true) {
                            furnishInstallCost += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)
      												*Number(gridEst.selectedValues[gI]);
                          }
    										}
    									}


    							} else {
    								// This is a normal slider
    								// start by getting the selection from our estimate
    								try	{
    									let sliderArrayPos = state.estimates[index][key].selectedSliderIndex === null ? 0 : state.estimates[index][key].selectedSliderIndex-1;
    									// cost +=  Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt ;
                      if (item.apply_general_conditions == true) {
                        genConCost +=  Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt ;
                      }
                      if (item.apply_furnish_install == true) {
                        furnishInstallCost +=  Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt ;
                      }

                      switch(item.item_title) {
                        case 'Select Project Finish Level' :
                          finishLevelCost = Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt;
                          cost +=  Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt;
                        break;
                        case 'Select Level of Finish for Existing Walls ' :
                          cost += Number(item.slider.stops[sliderArrayPos].stop_multiplier) * finishLevelCost;
                          if (item.apply_general_conditions == true) {
                            genConCost -=  Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt ;
                            genConCost += Number(item.slider.stops[sliderArrayPos].stop_multiplier) * finishLevelCost;
                          }
                        break;
                        default :
                          cost +=  Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt ;
                      }
    								} catch(e) {
                      console.log(e);
    								}
    							}
    						}
    					}
    				}
    			}
        }
  		}
  	}
  }

  // add healthcare general conditions
  for (const [k, v] of healthcareGenCost.entries()) {
    let hcGenCost = cost * (v/100);
    healthcareGenCost.set(k, hcGenCost);
  }
  for (const [k, v] of healthcareGenCost.entries()) {
    cost += healthcareGenCost.get(k);
  }

  // get the furnish design cost at $1 per sqFt, 2500 min
  let furnishDesignCost = 0;
  if (budget) {
    if (budget.id == 137 || budget.title.trim() == "Healthcare") {
      // do nothing
    } else {
      // add the furnish sq ft cost
      if (state.mandatories.projectSqFt > 2500) {
        furnishDesignCost = state.mandatories.projectSqFt;
      } else {
        furnishDesignCost = 2500;
      }
    }
  }

  cost += furnishDesignCost;
  cost += (furnishInstallCost * .05);

  // add general conditions
  let x = (state.mandatories.projectSqFt * 5.75);
  let y = (genConCost * .10);
  if (y > 0) {
    cost += ((x + y) / 2);
  }

	return {
		cost: cost
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(EstimateProgress);



// WEBPACK FOOTER //
// ./src/components/common/EstimateProgress.js